import { Textarea } from '@acpaas-ui/react-components';
import { useState } from 'react';
import Modal from './Modal';
import ModalTitle from './ModalTitle';

const CasetafelApproveModal = ({ isOpen, onClose, onConfirm, isCommission }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [remark, setRemark] = useState('');

  const handleClose = () => {
    setIsSubmitting(false);
    setError('');
    setRemark('');
    onClose();
  };

  const onApproveError = (error) => {
    setError(error);
    setIsSubmitting(false);
  };

  const onApproveSuccess = () => {
    setError('');
    setIsSubmitting(true);
    handleClose();
  };

  const handleConfirm = () => {
    setError('');
    setIsSubmitting(true);
    onConfirm(remark, onApproveError, onApproveSuccess);
  };

  return (
    <Modal
      title={<ModalTitle title={'Verslag bevestigen'} />}
      isOpen={isOpen}
      isSubmitting={isSubmitting}
      onClose={handleClose}
      onConfirm={handleConfirm}
      onConfirmLabel="Bevestigen"
      onConfirmIcon="ai-check-1"
      onConfirmType="success"
    >
      <Textarea label="Eventuele opmerkingen" value={remark} onChange={(e) => setRemark(e.target.value)} />
      {error && <small className="u-block u-margin-top-sm u-text-danger">{error}</small>}
    </Modal>
  );
};

export default CasetafelApproveModal;
